<template>
    <div>
        <div class="list">
            <div class="list-item">
                <div class="title">普通合伙人</div>
                <div class="part1"><span>下级:</span><el-input v-model="dataSet[20][0]" size="mini" maxlength="5"></el-input>%</div>
                <div class="part1"><span>下下级:</span><el-input v-model="dataSet[20][1]" size="mini" maxlength="5"></el-input>%</div>
            </div>
            <div class="list-item">
                <div class="title">高级合伙人</div>
                <div class="part1"><span>下级:</span><el-input v-model="dataSet[30][0]" size="mini" maxlength="5"></el-input>%</div>
                <div class="part1"><span>下下级:</span><el-input v-model="dataSet[30][1]" size="mini" maxlength="5"></el-input>%</div>
            </div>
            <div class="list-item">
                <div class="title">银牌合伙人</div>
                <div class="part1"><span>下级:</span><el-input v-model="dataSet[40][0]" size="mini" maxlength="5"></el-input>%</div>
                <div class="part1"><span>下下级:</span><el-input v-model="dataSet[40][1]" size="mini" maxlength="5"></el-input>%</div>
            </div>
            <div class="list-item">
                <div class="title">金牌合伙人</div>
                <div class="part1"><span>下级:</span><el-input v-model="dataSet[50][0]" size="mini" maxlength="5"></el-input>%</div>
                <div class="part1"><span>下下级:</span><el-input v-model="dataSet[50][1]" size="mini" maxlength="5"></el-input>%</div>
            </div>
            <div class="list-item">
                <div class="title">白金合伙人</div>
                <div class="part1"><span>下级:</span><el-input v-model="dataSet[60][0]" size="mini" maxlength="5"></el-input>%</div>
                <div class="part1"><span>下下级:</span><el-input v-model="dataSet[60][1]" size="mini" maxlength="5"></el-input>%</div>
            </div>
            <div class="list-item">
                <div class="title">钻石合伙人</div>
                <div class="part1"><span>下级:</span><el-input v-model="dataSet[70][0]" size="mini" maxlength="5"></el-input>%</div>
                <div class="part1"><span>下下级:</span><el-input v-model="dataSet[70][1]" size="mini" maxlength="5"></el-input>%</div>
            </div>
            <div class="tax-rate"><span>税率：</span><el-input v-model="tax_rate" size="mini" maxlength="5"></el-input>%</div>
        </div>
        <div class="btn-box">
            <el-button type="primary" size="small"  class="setting" @click="handleClickSetting">设置</el-button>
            <el-button type="primary" size="small" class="setting-default" @click="handleClickDefault">获取默认值</el-button>
        </div>
    </div>
</template>
<script>
import request from '../../api/request'
const LEVEL_LIST = [
    {a: '普通合伙人', level: 20},
    {a: '高级合伙人', level: 30},
    {a: '银牌合伙人', level: 40},
    {a: '金牌合伙人', level: 50},
    {a: '白金合伙人', level: 60},
    {a: '钻石合伙人', level: 70}
]
export default {
    data(){
        return {
            levelList: LEVEL_LIST,
            readonly: false,
            dataSet: {
                20: ['', ''],
                30: ['', ''],
                40: ['', ''],
                50: ['', ''],
                60: ['', ''],
                70: ['', ''],
            },
            tax_rate: 0
        }
    },
    mounted() {
        request.tools
            .post('rule_get', {"type":"partner_policy_commission"})
            .then(resp => {
                if(resp.data.rule) {
                    const level = resp.data.rule.level
                    for(let key  in level){
                        level[key] = this.getFormatArray(level[key])
                    }
                    this.dataSet = level
                    this.tax_rate = resp.data.rule.tax_rate/1E4
                }
            })
    },
    methods: {
        handleClickSetting(){
            this.$confirm(`确定设置保单佣金吗`)
                .then(() => {
                    this.settingFunc()
                })
        },
        settingFunc(){
            const levelArr = {}
            for(let key  in this.dataSet){
                levelArr[key] = this.setFormatArray(this.dataSet[key])
            }
            const data = {
                "type":"partner_policy_commission",
                "rule":
                    {
                        "level": levelArr,
                        "tax_rate": this.tax_rate * 1E4
                    }
            }
            request.tools
                .post('rule_set', data)
                .then(resp => {
                    if(resp.status === 0) {
                        this.$message.success('设置成功')
                    }
                })
        },
        handleClickDefault(){
            //默认配置
            request.tools
                .post('rule_default_get', {"type":"partner_policy_commission"})
                .then(resp => {
                    const level = resp.data.rule.level
                    for(let key  in level){
                        level[key] = this.getFormatArray(level[key])
                    }
                    this.dataSet = level
                    this.tax_rate = resp.data.rule.tax_rate/1E4
                })
        },
        getFormatArray(arr){
            const arr1 = []
            arr.forEach(item => {
                arr1.push(item/1E4)
            })
            return arr1
        },
        setFormatArray(arr){
            const arr1 = []
            arr.forEach(item => {
                arr1.push(item*1E4)
            })
            return arr1
        }
    }
}
</script>
<style scoped>
.el-input{
    width: 60px;
}
.list-item{
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 30px 0 0 0;
}
.list-item .title{
    margin: 0 50px 0 0;
}
.list-item .part1{
    margin: 0 30px 0 0;
}
.list-item .part1 span{
    margin: 0 10px 0 0;
}
.btn-box{
    margin: 30px 0 0 0;
}
.tax-rate{
    font-size: 18px;
    margin: 30px 0 0 0;   
}
</style>
